function discontinuity() {
  return true;
}

module.exports = discontinuity;
